import React from 'react';
import { cn } from '../../../utils/cn';

const SettingsContent = ({ 
  children,
  loading = false,
  className,
  ...props 
}) => {
  if (loading) {
    return (
      <main
        className={cn(
          'flex-1 bg-white shadow-sm overflow-y-auto',
          'md:rounded-l-2xl', // Only rounded on desktop
          'p-4 md:p-8',
          'flex items-center justify-center',
          className
        )}
        {...props}
      >
        <div className="text-center">
          <div className="animate-spin mx-auto mb-4 h-8 w-8 border-4 border-primary-500 border-t-transparent rounded-full"></div>
          <p className="text-gray-600">Loading configuration...</p>
        </div>
      </main>
    );
  }

  return (
    <main
      className={cn(
        'flex-1 bg-white shadow-sm overflow-y-auto',
        'md:rounded-l-2xl', // Only rounded on desktop
        className
      )}
      {...props}
    >
      <div className="p-4 md:p-8">
        {children}
      </div>
    </main>
  );
};

export default SettingsContent;